import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import swal from 'sweetalert';
import { AuthContext } from '../../../App/App';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Rating } from 'primereact/rating';

const ClientTypeTable = () => {
    const { stateAuth, dispatchAuth } = useContext(AuthContext)

    const [rows, setRows] = useState([])
    const [rowDetail, setRowDetail] = useState([])
    const [selectedRow, setSelectedRow] = useState(null);

    const [dialogVisible, setDialogVisible] = useState(false);


    const [dates, setDates] = useState([new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()), new Date()])

    useEffect(() => {
        getRowsData()

        return () => {
            setRows([])
        }
    }, [dates])

    useEffect(() => {
        if (selectedRow && selectedRow.Admin) {
            setRowDetail([])
            getRowsDataDetail(selectedRow.Admin)
        }
    }, [selectedRow])

    const getRowsData = () => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            },
            params: { start_date: dates[0], end_date: dates[1] }
        }

        axios.get(`/api/v1/helpdesk/dashboard/client-type`, config)
            .then(res => {
                setRows(res.data.data)
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again!!!'
                        })
                    } else if (err.response.data.message) {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const getRowsDataDetail = (admin) => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            },
            params: { start_date: dates[0], end_date: dates[1] }
        }

        axios.get(`/api/v1/helpdesk/dashboard/client-type/${admin}`, config)
            .then(res => {
                setRowDetail(res.data.data)
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again!!!'
                        })
                    } else if (err.response.data.message) {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })

    }

    const selectedDates = (e) => {
        setDates(e.value)
    }

    const onRowSelect = (event) => {
        setDialogVisible(true)
    };

    const onRowUnselect = () => {
        setDialogVisible(false)
        setSelectedRow(null)
    };

    const ratingTemplate = (rating) => {
        return <Rating value={rating} readOnly cancel={false} tooltip={rating} tooltipOptions={{ position: 'mouse' }} />;
    };

    const categoryTableFooter = () => {
        const messageTotal = rows.map(row => row.Complaint).reduce((acc, cur) => acc + cur, 0)
        return (
            <ColumnGroup>
                <Row>
                    <Column footer="Total Message:" colSpan={3} footerStyle={{ textAlign: 'right' }} />
                    <Column footer={messageTotal} />
                </Row>
            </ColumnGroup>
        )
    }


    const detailCategoryTableFooter = () => {
        return <Button label="Ok" icon="pi pi-check" onClick={() => onRowUnselect()} />;
    };

    return (
        <>
            <div className="card p-4 mx-1">
                <h1 className='font-weight-bold pb-3'>Admin</h1>
                <div className="container mb-3 mx-0 p-0">
                    <div className="col-6 p-0 w-full">
                        <Calendar value={dates} onChange={selectedDates} selectionMode="range" dateFormat="dd/mm/yy" maxDate={new Date()} readOnlyInput placeholder='Date' />
                    </div>
                </div>

                <DataTable value={rows} size='small' selectionMode="single" selection={selectedRow} onSelectionChange={(e) => setSelectedRow(e.value)} dataKey="Admin_Id" onRowSelect={onRowSelect} onRowUnselect={onRowUnselect} metaKeySelection={false} footerColumnGroup={categoryTableFooter()} tableStyle={{ width: '100%' }}>
                    <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}></Column>
                    <Column field="Admin" header="Admin Name" className='mx-5'></Column>
                    <Column field="Rating" header="Rating" body={(data) => ratingTemplate(data.Rating_Filled ? (data.Rating / data.Rating_Filled).toFixed(2) : 0)} className='mx-5'></Column>
                    <Column field="Complaint" header="Message" className='mx-5 text-center'></Column>
                </DataTable>
            </div >

            <Dialog header={`Admin : ${selectedRow && selectedRow.Admin ? selectedRow.Admin : ''}`} visible={dialogVisible} style={{ width: '75vw' }} maximizable modal contentStyle={{}} onHide={() => setDialogVisible(false)} footer={detailCategoryTableFooter}>
                <DataTable value={rowDetail} size='small' dataKey="Detail_Category_Id" metaKeySelection={false} tableStyle={{ maxHeight: '60vh' }} scrollable scrollHeight="450px" paginator rows={10}>
                    <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}></Column>
                    <Column field="Platform" header="Platform" className='mx-5'></Column>
                    <Column field="Clinet_Type_Name" header="Client" className='mx-5'></Column>
                    <Column field="User_Name" header="Name" className='mx-5'></Column>
                    <Column field="Rating" header="Rating" body={(data) => ratingTemplate(data.Rating ? data.Rating : 0)} className='mx-5'></Column>
                    <Column field="Feedback" header="Feedback" className='mx-5'></Column>
                </DataTable>
            </Dialog>
        </>
    )
}

export default ClientTypeTable